<template>
    <div class="discountCoupon">
        <ul class="efficacious" v-for="(coupon,index) in couponInfoArr" :key="index">
            <li><span>有效</span></li>
            <li>
                <div class="discount_price">
                    <span>{{coupon.money2}}</span>
                </div>
                <div class="condition">
                    <p>{{coupon.condition2}}元使用，不可叠加</p>
                    <span @click="goToBuy()">立即使用</span>
                </div>

            </li>
        </ul>
        <!-- <ul class="invalid">
            <li><span>无效</span></li>
            <li>
                <div class="discount_price">
                    <span>10</span>
                </div>
                <div class="condition">
                    <p>299元使用，不可叠加</p>
                    <span>立即使用</span>
                </div>
            </li>
        </ul> -->
    </div>
</template>

<script>
    export default {
        name: "discountCoupon",
        data: function () {
            return {
                couponInfoArr:""
            }
        },
        created: function () {
            this.getCouponsInfoArr(0);
        },
        computed: {
            weburl: function () {
                return this.$store.state.weburl;
            },
            hurl: function () {
                return this.$store.state.hurl;
            }
        },
        methods:{
            // 立即使用的方法
            goToBuy: function () {
                this.$router.push({ path: '/market'});
            },
            // 获得优惠卷的方法
            getCouponsInfoArr: function (num) {
                this.$http({
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    method: "post",
                    url: this.weburl + this.hurl + "/user/coupon",
                    dataType:"json",
                    data:{
                        type:num
                    }
                })
                .then( res => {
                    if(res.data.status == 1){
                        this.couponInfoArr = res.data.result;
                        console.log(this.couponInfoArr);
                    }
                })
                .catch( err => {
                    Toast("系统错误,请稍后再试!");
                    console.log(err);
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../assets/less/Common.less';

    .discountCoupon {
        width: 90%;
        margin:  auto;
        ul {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            color: @font-primary;
            height: 65px;
            margin-bottom: 10px;
            & li {
                height: 65px;
                &:first-child {
                    flex: 1;
                    span {
                        padding: 2px 9px 4px;
                        .border-radius(6px);
                        font-size: .8rem;
                        line-height: 65px;
                    }
                }
                &:last-child {
                    flex: 3;
                    .discount_price {
                        float: left;
                        width: 31%;
                        height: 65px;
                        font-size:2.2rem;
                        line-height:$height ;
                        text-align: center;
                        position: relative;
                        &:before {
                            content: '￥';
                            font-size: 0.9rem;
                            top: -6px;
                            left: 7px;
                        }
                    }
                    .condition {
                        height: 65px;
                        float: left;
                        width: 69%;
                        text-align: center;
                        .box-sizing;
                        padding: 5px 0;
                        p{
                            margin-bottom: 10px;
                        }
                        span {
                            padding: 1px 20%;
                            background-color:#fe7096 ;
                            .border-radius(20px);
                            font-size: .8rem;
                        }
                    }
                }
            }
            &.efficacious {
                & li {
                    &:first-child {
                        span {
                            background: @subject_color;
                        }
                    }
                    &:last-child {
                        background: url(../../assets/images/personalCenter/discount_1.png) no-repeat;
                        background-size: 253px auto;
                    }
                }
            }
            &.invalid {
                -webkit-filter:grayscale(100%);
                -moz-filter:grayscale(100%);
                -ms-filter:grayscale(100%);
                -o-filter:grayscale(100%);
                filter:grayscale(100%);
                & li {
                    span {
                        background: tint(@word, 50%);
                    }
                    &:last-child {
                        background: url(../../assets/images/personalCenter/discount_2.png) no-repeat;
                        background-size: 253px auto;
                        .condition {
                            span {
                                background-color: tint(@word, 50%);

                            }
                        }
                    }
                }
            }
        }

    }


</style>
